// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const NeedMet = zod.object({
  "how": zod.string(),
  "need": zod.string()
});

export type NeedMet = zod.input<typeof NeedMet>;
export type NeedMetOutput = zod.output<typeof NeedMet>;
